import { useCallback, useEffect, useRef, useState } from 'react';

const RELEASE_MS = 1000;

export const useTouchFrozen = <T>(items: T): { items: T; onTouchStart: () => void; onTouchEnd: () => void } => {
  const [touching, setTouching] = useState(false);
  const [shown, setShown] = useState(items);
  const release = useRef<number | null>(null);

  useEffect(() => {
    if (!touching) setShown(items);
  }, [touching, items]);

  useEffect(() => () => {
    if (release.current !== null) window.clearTimeout(release.current);
  }, []);

  const onTouchStart = useCallback(() => {
    if (release.current !== null) window.clearTimeout(release.current);
    release.current = null;
    setTouching(true);
  }, []);

  const onTouchEnd = useCallback(() => {
    if (release.current !== null) window.clearTimeout(release.current);
    release.current = window.setTimeout(() => {
      release.current = null;
      setTouching(false);
    }, RELEASE_MS);
  }, []);

  return { items: shown, onTouchStart, onTouchEnd };
};
